import { combineReducers } from 'redux';
import Theme from './Theme';
import Account from './Account';
import User from './User';
import Notifications from './Notifications';
import Contacts from './Contacts';
import Users from './Users';
import Groups from './Groups';
import Clients from './Clients'; 
import ClientStatuses from './ClientStatuses';
import LeadSources from './LeadSources';
import LinkedDevices from './LinkedDevices';
import Employees from './Employees';
import Quotes from './Quotes';
import Requests from './Requests';
import Jobs from './Jobs';
import Invoices from './Invoices';
import Loader from './Loader'

const reducers = combineReducers({
  theme: Theme,
  account: Account,
  user: User,
  contacts: Contacts,
  users: Users,
  notifications: Notifications,
  groups: Groups,
  clients: Clients, 
  client_statuses: ClientStatuses,
  lead_sources: LeadSources,
  linked_devices: LinkedDevices,
  employees: Employees,
  loader: Loader,
  quotes: Quotes,
  requests: Requests,
  jobs: Jobs,
  invoices: Invoices,
});

export default reducers;